// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"19d589ab","78":"55a12443","80":"ee22ed5c","105":"f49ddcef","392":"5ab64c28","899":"7376c958","937":"5777e709"}[chunkId] + ".chunk.js";
};